export default "__VITE_ASSET__BtNTSA2l__"